<div class="container-fluid text-white" style="background-color: #fd7e14">
    <div>
        <div class="row row-cols-sm-2 text-center flex-column-reverse flex-lg-row flex-md-row row-cols-lg-2">
            <div style="margin-top: 17px">
                <p>Designed and Devloped by Tedlance Solutions Pvt Ltd</p>
            </div>
            <div class="text-white" style="font-size: 11px; margin-top: 17px">
                <a href="#"> <i class="fa-brands fa-facebook-f fa-2x px-2" style="color: white"></i></a>
                <a href="#"> <i class="fa-brands fa-twitter fa-2x px-2" style="color: white"></i></a>
                <a href="#"> <i class="fa-brands fa-instagram fa-2x px-2" style="color: white"></i></a>
            </div>
        </div>
    </div>
</div>
